<div class="et-lap">
    <ion-card>
      <ion-card-header>
        <ion-card-title>Értékelés-típusok</ion-card-title>
        <ion-card-subtitle>
          Röpdolgozat, témazáró, felelet… — a <b>súly</b> dönti el, mennyit nyom az átlagban,
          a <b>szín</b> pedig azt, mennyire ugrik ki a jegy a naplóban.
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <div *ngIf="toltodik">Betöltés…</div>
        <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>

        <!--  HOGYAN ÍRJA BE A TANÁR A JEGYET. Öt lehetséges érték – gombbal egy
              koppintás, és nem lehet elgépelni. A százalékos és a fokozatos
              értékelés ettől függetlenül a saját beviteli módját kapja. -->
        <div class="et-beallitas">
          <ion-toggle [(ngModel)]="jegyGombok" (ionChange)="jegyGombokMent()" [disabled]="beallitasMentes">
            Jegybeírás <b>gombokkal</b> (1–5), begépelés helyett
          </ion-toggle>
          <ion-note color="medium">
            Ez az alapértelmezés. Kikapcsolva a tanár szövegmezőbe írja a jegyet.
            A <b>százalékos</b> értékelésnél a mező marad, mert ott a gombsor nem segítene.
            A változás azonnal érvényes, nem kell újra belépni.
          </ion-note>
        </div>

        <!--  JEGYBEÍRÁSI (ÉRTESÍTÉSI) HATÁRIDŐ – 20/2012. EMMI r. 64. § (1a), 7. § (1) aj):
              a pedagógiai program rögzíti. Csak jelez, nem tilt. -->
        <div class="et-beallitas">
          <div class="et-hatarido">
            <ion-input label="Jegybeírási határidő (nap)" labelPlacement="stacked" fill="outline" type="number"
                       min="0" max="365" placeholder="nincs figyelés" [(ngModel)]="hataridoBemenet"
                       [disabled]="hataridoMentes"></ion-input>
            <ion-button size="small" color="success" (click)="hataridoMent()"
                        [disabled]="hataridoMentes || !hataridoModosult">
              <ion-icon slot="start" name="save-outline"></ion-icon>Mentés
            </ion-button>
          </div>
          <ion-note color="medium">
            A jegy napjától számítva hány napon belül kell a jegyet a naplóba beírni – a
            <b>pedagógiai programban</b> rögzített értesítési határidő (20/2012. EMMI rendelet 64. § (1a)).
            Üresen hagyva nincs figyelés. A határidőn túl beírt jegy is bemegy, a tanár a mentéskor
            figyelmeztetést kap. Az évközi jegyekre és a <b>negyedéves</b> (I–IV.) értékelésre vonatkozik,
            ugyanazzal a nappal; a félévi és az év végi osztályzatra nem. Csak a nálunk beírt jegy számít
            (a KRÉTÁ-ból átvett, a stornózott és a „nem írta meg” jelölés nem).
          </ion-note>
        </div>

        <!--  KÉSVE BEÍRT JEGYEK tanáronként: beírás napja − jegy napja > határidő. -->
        <div class="et-beallitas" *ngIf="hataridoNap !== null || kesve">
          <div class="et-kesve-fej">
            <b>Késve beírt jegyek</b>
            <ion-input label="A jegy napja ettől" labelPlacement="stacked" fill="outline" type="date"
                       [(ngModel)]="kesveTol"></ion-input>
            <ion-input label="eddig" labelPlacement="stacked" fill="outline" type="date"
                       [(ngModel)]="kesveIg"></ion-input>
            <ion-button size="small" fill="outline" (click)="kesveBetolt()" [disabled]="kesveToltodik">
              <ion-icon slot="start" name="search-outline"></ion-icon>Lekérdezés
            </ion-button>
          </div>
          <div *ngIf="kesveToltodik">Betöltés…</div>
          <ion-note color="danger" *ngIf="kesveHiba">{{ kesveHiba }}</ion-note>
          <ng-container *ngIf="kesve && !kesveToltodik">
            <ion-note color="medium" *ngIf="!kesve.figyeles">
              Nincs beállított jegybeírási határidő, ezért nincs mit listázni.
            </ion-note>
            <ion-note color="medium" *ngIf="kesve.figyeles && !kesve.tanarok?.length">
              A {{ kesve.idoszak?.tol }} – {{ kesve.idoszak?.ig }} időszakban nincs a {{ kesve.hatarido_nap }} napos
              határidőn túl beírt jegy.
            </ion-note>
            <ng-container *ngIf="kesve.figyeles && kesve.tanarok?.length">
              <ion-note color="medium">
                {{ kesveOsszes }} jegy került be a {{ kesve.hatarido_nap }} napos határidőn túl
                ({{ kesve.idoszak?.tol }} – {{ kesve.idoszak?.ig }}). A sorra kattintva a tételes lista nyílik.
              </ion-note>
              <table class="et-tabla et-kesve">
                <thead>
                  <tr>
                    <th>Tanár</th><th class="sz">Késve beírt jegy</th><th class="sz">ebből negyedéves</th><th class="sz">Alkalom</th>
                    <th class="sz">Legnagyobb késés</th><th class="sz">Átlagos késés</th><th class="sz">Utolsó beírás</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let t of kesve.tanarok">
                    <tr class="et-kesve-sor" (click)="kesveTanar(t)" [class.nyitott]="kesveNyitott === t.adid">
                      <td>{{ t.nev }}</td><td class="sz">{{ t.db }}</td><td class="sz">{{ t.negyedeves_db || '–' }}</td><td class="sz">{{ t.alkalom }}</td>
                      <td class="sz">{{ t.max_keses }} nap</td><td class="sz">{{ t.atlag_keses }} nap</td>
                      <td class="sz">{{ t.utolso_beiras }}</td>
                    </tr>
                    <tr *ngIf="kesveNyitott === t.adid">
                      <td colspan="7" class="et-kesve-tetel">
                        <div *ngIf="kesveTetelToltodik">Betöltés…</div>
                        <table *ngIf="!kesveTetelToltodik && kesveTetelek.length">
                          <thead>
                            <tr><th>Jegy napja</th><th>Beírva</th><th class="sz">Késés</th><th>Osztály</th>
                              <th>Tantárgy</th><th>Tanuló</th><th>Jegy</th><th>Típus / téma</th></tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let j of kesveTetelek">
                              <td>{{ j.targynap }}</td><td>{{ j.beirva }}</td><td class="sz">{{ j.keses_nap }} nap</td>
                              <td>{{ j.osztaly }}</td><td>{{ j.tantargy }}</td><td>{{ j.tanulo }}</td>
                              <td>{{ j.ertekeles }}</td>
                              <td><b *ngIf="j.negyedeves">{{ j.negyedeves }}</b><ng-container *ngIf="!j.negyedeves">{{ j.tipus }}</ng-container><span *ngIf="j.tema"> · {{ j.tema }}</span></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </ng-container>
          </ng-container>
          <ion-button *ngIf="!kesve && !kesveToltodik && !kesveHiba" size="small" fill="clear" (click)="kesveBetolt()">
            Lista megnyitása
          </ion-button>
        </div>

        <div class="et-uj" *ngIf="!toltodik">
          <ion-button size="small" fill="outline" (click)="ujNyitva = !ujNyitva">
            <ion-icon slot="start" name="add-circle-outline"></ion-icon>Új típus
          </ion-button>
        </div>

        <div class="et-uj" *ngIf="ujNyitva">
          <ion-input label="Név" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.nev"
                     placeholder="pl. Témazáró dolgozat"></ion-input>
          <ion-input label="Súly (%)" labelPlacement="stacked" fill="outline" type="number"
                     [(ngModel)]="uj.szorzo" style="max-width:140px"></ion-input>
          <ion-input label="KRÉTA neve" labelPlacement="stacked" fill="outline" [(ngModel)]="uj.kreta"
                     placeholder="ha eltér"></ion-input>
          <input type="color" [(ngModel)]="uj.szin" title="Szín">
          <ion-button size="small" color="success" (click)="ujMent()">
            <ion-icon slot="start" name="save-outline"></ion-icon>Felvétel
          </ion-button>
        </div>

        <table class="et-tabla" *ngIf="!toltodik && tipusok.length">
          <thead>
            <tr>
              <th>Név</th><th style="width:110px">Súly (%)</th><th style="width:80px">Szorzó</th>
              <th style="width:70px">Szín</th><th>KRÉTA neve</th>
              <th style="width:110px">Használat</th><th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let t of tipusok" [class.et-zarolt]="t.technikai" [class.et-rejtett]="t.rejtett">
              <td>
                <input type="text" [(ngModel)]="t.nev" [disabled]="t.technikai">
                <small class="et-rejtett-jel" *ngIf="t.rejtett">rejtett – a tanárok nem választhatják</small>
              </td>
              <td><input type="number" [(ngModel)]="t.szorzo" [disabled]="t.technikai" min="0" max="1000"></td>
              <td class="et-szorzo">{{ szorzoSzoveg(t) }}</td>
              <td><input type="color" [(ngModel)]="t.szin" [disabled]="t.technikai"></td>
              <td><input type="text" [(ngModel)]="t.kreta" [disabled]="t.technikai"
                         placeholder="ha eltér a névtől"></td>
              <td>
                <span *ngIf="t.hasznalat">{{ t.hasznalat }} jegy</span>
                <span *ngIf="t.szamonkeres"><br *ngIf="t.hasznalat">{{ t.szamonkeres }} számonkérés</span>
                <span *ngIf="!t.hasznalat && !t.szamonkeres" style="color:var(--ion-color-medium)">nincs használva</span>
              </td>
              <td class="muvelet">
                <!--  Technikai típus: a felület a „-” nevéről ismeri fel, ezért zárolt. -->
                <ion-icon *ngIf="t.technikai" name="lock-closed-outline" color="medium"
                          title="Technikai típus (szöveges félévi/év végi értékelés) – nem módosítható"></ion-icon>
                <ion-button size="small" fill="clear" color="success" *ngIf="!t.technikai && modosult(t)"
                            (click)="ment(t)">
                  <ion-icon slot="icon-only" name="save-outline"></ion-icon>
                </ion-button>
                <ion-button size="small" fill="clear" color="medium" *ngIf="!t.technikai" (click)="rejtes(t)"
                            [title]="t.rejtett ? 'Megjelenítés – újra választható lesz' : 'Elrejtés – a tanárok nem választhatják, a meglévő jegyek maradnak'">
                  <ion-icon slot="icon-only" [name]="t.rejtett ? 'eye-outline' : 'eye-off-outline'"></ion-icon>
                </ion-button>
                <!-- A letiltott gomb nem kap kattintást, ezért a magyarázat a burkoló címében van. -->
                <span *ngIf="!t.technikai" [title]="torlesCim(t)">
                  <ion-button size="small" fill="clear" color="danger" (click)="torol(t)" [disabled]="!torolheto(t)">
                    <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
                  </ion-button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>

        <ion-note color="medium" style="display:block;margin-top:10px;font-size:.85rem">
          A típusok nevét, súlyát, színét és KRÉTA-nevét itt közvetlenül módosíthatod; a súly
          változása a <b>már beírt jegyek</b> átlagára is hat. A két <b>„-”</b> nevű típus
          technikai (a szöveges félévi/év végi értékelésé), ezért zárolt.
          <b>Törölni</b> csak azt a típust lehet, amelyhez még nincs beírt jegy vagy számonkérés.
          A használatban lévőt <b>elrejtheted</b> (szem ikon): a tanárok nem választhatják többé,
          a meglévő jegyek viszont változatlanok maradnak.
        </ion-note>
      </ion-card-content>
    </ion-card>
</div>
